import React, { useEffect, useState } from 'react';
import 'firebase/database';

import { addUser } from '../../App'
import '../SignUp/signup.css'

import { Image } from 'react-bootstrap';
import { StyledAdminPage, StyledUserSection } from './admin.styles';
import { getAllUsers, getUsersByLevel, setUserLevel } from '../../Datahandler';
import AdminUserTable from './UserTable';
import { useSelector } from 'react-redux';


const Admin = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    title: '',
    project: '',
    imgurl: '',
  });

  const [pendingUsers, setPendingUsers] = useState([]);
  const [users, setUsers] = useState([]);

  const currentUser = useSelector(state => state.user.loggedInUser);

  useEffect(() => {
    getUsersByLevel(0).then((res) => {
      setPendingUsers(res);
    });
    getAllUsers().then((res) => {
      setUsers(Object.values(res).filter(user => user.level !== 0));
    })
  }, []);

  const handleInputChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const handleUserLevel = (userId, level, originalLevel) => {
    setUserLevel(userId, level);
    if (originalLevel === 0) {
      setPendingUsers(pendingUsers.filter(user => user.userId !== userId))
    }
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    alert(`Great - you have been added as: ` + formData.name)
    addUser(
      formData.name,
      formData.email,
      formData.title,
      formData.project.
        null)
    // you can send the form data to the server for storage here
  };

  return (

    currentUser?.level >= 1000 ? <StyledAdminPage>
      <h1>Admin</h1>
      {pendingUsers.length > 0 && <StyledUserSection>
        <h2>Pending Users</h2>
        <AdminUserTable users={pendingUsers} setUserLevel={handleUserLevel} />
      </StyledUserSection>}
      <StyledUserSection>
        <h2>User Management</h2>
        <AdminUserTable users={users} setUserLevel={setUserLevel} />
      </StyledUserSection>
      <div className="container">
        <Image src="../img/riot-transp-logo.png" alt="RIOT Labs logo" height="130px" />
        <form onSubmit={handleSubmit} className="signup-container">
          <div className="signup-label">
            <label htmlFor="name" >Name:</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
            />
          </div>
          <div className="signup-label">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
            />
          </div>
          <div className="signup-label">
            <label htmlFor="title">Title:</label>
            <input
              type="text"
              id="title"
              name="title"
              value={formData.title}
              onChange={handleInputChange}
            />
          </div>
          <div className="signup-label">
            <label htmlFor="project">Project:</label>
            <br />
            <select
              id="project"
              name="project"
              value={formData.project}
              onChange={handleInputChange}
            >
              <option value="">Select a project</option>
              <option value="get-awAI">get-awAI</option>
              <option value="AR-sembly">AR-sembly</option>
              <option value="Mashupper">Mashupper</option>
              <option value="MalmoLive">MalmoLive</option>
              <option value="DataViz">DataViz</option>
              <option value="Anyone">Anyone, they are all amazing</option>
            </select>
          </div>
          <br />
          <button type="submit" className="signup-label">Submit</button>
        </form>
      </div>
    </StyledAdminPage> : <p>You do not have access to this page.</p>

  );
};

export default Admin;
